module.exports = __webpack_public_path__ + "static/media/productos_botanas_maiz_habanero.23032e7f.png";